import {appApi} from "./api.service";
import {Geolocation} from "@capacitor/geolocation";
import {Device} from "@capacitor/device";

const endpointPrefix = 'specification-viewer';

export const getSpecificationAvailability = async (reportId: string | number) => {
    return appApi.get(endpointPrefix + '/availability/' + reportId);
}

export const getSpecificationView = async (specificationId: string | number, lang: string) => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    return appApi.get(endpointPrefix + '/view/' + specificationId, {
        params: {
            latitude: coordinates.coords.latitude,
            longitude: coordinates.coords.longitude,
            lang: lang
        }
    });
}

export const postAcknowledge = async (specificationId: string | number, reportId: string | number) => {
    const coordinates = await Geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        maximumAge: 0
    });
    const device = await Device.getInfo();
    return appApi.post(endpointPrefix + '/acknowledge', {
        specificationId: specificationId,
        reportId: reportId,
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude,
        deviceName: device.model + ' (' + device.osVersion + ')',
        scrolledToBottom: true,
    });
}

export const getAcknowledgmentStatus = async (specificationId: string | number) => {
    return appApi.get(endpointPrefix + '/acknowledgment-status/' + specificationId);
}
